var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 6.65625C4.54844 6.65625 4.28125 6.92344 4.28125 7.25V8.07012L10.6826 13.3248C11.4508 13.9557 12.5529 13.9557 13.3211 13.3248L19.7188 8.07012V7.25C19.7188 6.92344 19.4516 6.65625 19.125 6.65625H4.875ZM4.28125 10.3746V16.75C4.28125 17.0766 4.54844 17.3438 4.875 17.3438H19.125C19.4516 17.3438 19.7188 17.0766 19.7188 16.75V10.3746L14.4492 14.7016C13.0242 15.8705 10.9721 15.8705 9.55078 14.7016L4.28125 10.3746ZM2.5 7.25C2.5 5.94004 3.56504 4.875 4.875 4.875H19.125C20.435 4.875 21.5 5.94004 21.5 7.25V16.75C21.5 18.06 20.435 19.125 19.125 19.125H4.875C3.56504 19.125 2.5 18.06 2.5 16.75V7.25Z",
    fill: "#83D9FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ca1dad274dd631aefca8e7e00a7337fa.svg";
export { ForwardRef as ReactComponent };